import { atom } from "recoil";
import Accommodation from "../models/Accommodation";

export const newListingState = atom({
  key: "newListingState",
  default: Accommodation.getEmptyAccommodationAsObj(),
});
